module.exports = __webpack_public_path__ + "static/img/CHELSEA-ITALIAN-WALNUT.38d1787.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CHELSEA-ITALIAN-WALNUT.png
// module id = pTYK
// module chunks = 0